import { Hit } from "@algolia/client-search";
import { IconButton, makeStyles } from "@material-ui/core";
import ProfileIcon from "@material-ui/icons/ArrowForwardOutlined";

import { CustomerDocument } from "../../customer.model";
import { CustomerSearchResultCard } from "./CustomerSearchResultCard";
import { useGoToCustomerProfile } from "../../go-to-customer-profile.hook";

const useStyles = makeStyles({
    icon: {
        fontSize: "24px",
        color: "#297A1D",
    },
});

interface ListItemProps {
    customer: Hit<CustomerDocument>;
}

export const ListItem = (props: ListItemProps) => {
    const classes = useStyles();

    const { customer } = props;

    const goToCustomerProfile = useGoToCustomerProfile("all", customer.id);

    const button = (
        <IconButton aria-label="go to customer profile" onClick={goToCustomerProfile}>
            <ProfileIcon className={classes.icon} />
        </IconButton>
    );

    return <CustomerSearchResultCard customer={customer} button={button} />;
};
